import { DataRetentionSettingsState } from './partials/dataRetention'
import { DocketwiseSettingsState } from './partials/docketwise'
import { EngagementLetterState } from './partials/engagementLetter'
import { GenericModelSettingsState } from './partials/genericModel'
import { InvoicedSettingsState } from './partials/invoiced'
import { LegalCasePartySliderSettingsState } from './partials/legalCasePartySlider'
import { LegalCasesSettingsState } from './partials/legalCases'
import { MaintenanceSettingsState } from './partials/maintenance'
import { MiscSettingsState } from './partials/misc'
import { MultifactorAuthenticationSettingsState } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsState } from './partials/otherDocketEntries'
import { PermissionsSettingsState } from './partials/permissions'
import { RecordsSettingsState } from './partials/records'
import { SessionManagementSettingsState } from './partials/sessionManagement'
import { SettingsSharedState } from './partials/shared'
import { SharepointSettingsState } from './partials/sharepoint'
import { TimezoneSettingsState } from './partials/timezone'
import { TmetricSettingsState } from './partials/tmetric'
import { TwilioSettingsState } from './partials/twilio'
import { UserAccessSettingsState } from './partials/usersAccess'
import { UserSettingsState } from './partials/user'
import { WorkflowSettingsState } from './partials/workflows'

export const SettingsState = _ => ({
  ...DataRetentionSettingsState,
  ...DocketwiseSettingsState,
  ...EngagementLetterState,
  ...GenericModelSettingsState,
  ...InvoicedSettingsState,
  ...LegalCasePartySliderSettingsState,
  ...LegalCasesSettingsState,
  ...MaintenanceSettingsState,
  ...MiscSettingsState,
  ...MultifactorAuthenticationSettingsState,
  ...OtherDocketEntriesSettingsState,
  ...PermissionsSettingsState,
  ...RecordsSettingsState,
  ...SessionManagementSettingsState,
  ...SettingsSharedState,
  ...SharepointSettingsState,
  ...TimezoneSettingsState,
  ...TmetricSettingsState,
  ...TwilioSettingsState,
  ...UserAccessSettingsState,
  ...UserSettingsState,
  ...WorkflowSettingsState,
})
